export interface DependentFormValues {
  tempId: string
  firstName: string
  lastName: string
  ssn: string
  dateOfBirth: string
  sex: 'Male' | 'Female' | ''
  /**
   * Wizard-side relationship. Narrowed to Spouse | Child per EOM-225; the BE
   * accepts only `^(SPOUSE|CHILD)$`. Read-only views of legacy data
   * (DependentDetailContent, partner-api/mappers) keep handling
   * DOMESTIC_PARTNER / LIFE_PARTNER for display purposes only.
   */
  relationship: 'Spouse' | 'Child' | ''
  isHandicapped: boolean
}

export interface AddEmployeeFormValues {
  // Step 1: Demographics
  firstName: string
  lastName: string
  ssn: string
  dateOfBirth: string
  sex: 'Male' | 'Female' | ''
  email: string
  phone: string
  street: string
  unit: string
  city: string
  state: string
  zip: string
  // Step 2: Employment.
  // EOM-228 dropped location/division/department/jobClass/jobTitle from this
  // form; the BE has no columns for them and the wizard no longer collects them.
  // Add them back only if the BE adds matching columns.
  hireDate: string
  employeeId: string
  subgroup: string
  // Step 3: Dependents
  dependents: DependentFormValues[]
  // Step 4: Benefits
  planId: string
  coverageTier: string
  effectiveDate: string
}

export const ADD_EMPLOYEE_STEPS = [
  'Details',
  'Employment',
  'Dependents',
  'Benefits',
  'Review',
] as const

export type AddEmployeeStep = (typeof ADD_EMPLOYEE_STEPS)[number]

export const INITIAL_EMPLOYEE_VALUES: AddEmployeeFormValues = {
  firstName: '',
  lastName: '',
  ssn: '',
  dateOfBirth: '',
  sex: '',
  email: '',
  phone: '',
  street: '',
  unit: '',
  city: '',
  state: '',
  zip: '',
  hireDate: '',
  employeeId: '',
  subgroup: '',
  dependents: [],
  planId: '',
  coverageTier: '',
  effectiveDate: '',
}

export function calculateCoverageTier(
  dependents: DependentFormValues[],
): string {
  if (dependents.length === 0) return 'EMP'
  const hasSpouse = dependents.some(d => d.relationship === 'Spouse')
  const hasChildren = dependents.some(d => d.relationship === 'Child')
  if (hasSpouse && hasChildren) return 'FAM'
  if (hasSpouse) return 'ESP'
  if (hasChildren) return 'ECH'
  return 'EMP'
}
